function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  const matchResult = formatString.match(placeholderRegex);
  if (!matchResult) {
    return formatString;
  }
  switch (matchResult[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

Shopify.formatMoney = formatMoney;

const modalOverlay = document.querySelector(".modal-overlay");

class MultiblockSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slidesPerViewDesktop = this.getAttribute(
      "data-slides-per-view-desktop"
    );
    this.slidesPerViewMobile = this.getAttribute("data-slides-per-view-mobile");
    this.init();
  }

  init() {
    this.swiper = new Swiper(this, {
      slidesPerView: this.slidesPerViewMobile,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewDesktop,
          spaceBetween: 28,
        },
      },
    });
  }
}

if (!window.customElements.get("multiblock-swiper")) {
  window.customElements.define("multiblock-swiper", MultiblockSwiper);
}

class NumberTicker extends HTMLElement {
  connectedCallback() {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: no-preference)"
    ).matches;

    if (reduceMotion) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.processTicker();
              observer.unobserve(this);
            }
          });
        },
        {
          threshold: 0.1,
        }
      );

      observer.observe(this);
    } else {
      const valueTo = parseInt(this.getAttribute("data-to-value")) || 0;
      const targetElement = this.querySelector("[data-counter-number]");
      targetElement.innerText = valueTo;
    }
  }

  processTicker() {
    const duration = parseInt(this.getAttribute("data-duration")) || 2000;
    const valueTo = parseInt(this.getAttribute("data-to-value")) || 0;
    const valueFrom = 0;

    let number = valueFrom;
    const incrementStep = Math.ceil((valueTo - valueFrom) / 100);
    const durationStep = duration / 100;

    const targetElement = this.querySelector("[data-counter-number]");

    const interval = setInterval(() => {
      targetElement.innerText = number;

      if (number >= valueTo) {
        clearInterval(interval);
        targetElement.innerText = valueTo;
      }

      number += incrementStep;
    }, durationStep);
  }
}

if (!window.customElements.get("number-ticker")) {
  window.customElements.define("number-ticker", NumberTicker);
}

class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("[data-quick-add-button]");
    this.modal = this.querySelector("quick-add-modal");
    this.bindEvents();
  }

  bindEvents() {
    if (!this.button || !this.modal) return;

    this.button.addEventListener("click", (event) => {
      event.preventDefault();
      this.open();
    });

    this.modal.addEventListener("click", (event) => {
      if (event.target === this.modal) {
        this.close();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.modal.classList.contains("active")) {
        this.close();
      }
    });

    const closeButton = this.modal.querySelector("[data-quick-add-close]");
    if (closeButton) {
      closeButton.addEventListener("click", this.close.bind(this));
    }
  }

  open() {
    this.modal.open();
  }

  close() {
    this.modal.close();
  }
}

if (!window.customElements.get("quick-add")) {
  window.customElements.define("quick-add", QuickAdd);
}

class QuickAddModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    if (modalOverlay) modalOverlay.addEventListener("click", this.close.bind(this));
    this.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
  }

  open() {
    this.classList.add("active");
  }

  close() {
    this.classList.remove("active");
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;

    const images = this.querySelectorAll(".quick-add-modal__image");
    const matchingImage = Array.from(images).find(
      (image) => parseInt(image.dataset.variantId) === variant.id
    );

    if (matchingImage) {
      images.forEach((image) =>
        image.classList.toggle("hidden", image !== matchingImage)
      );
    }
  }
}

if (!window.customElements.get("quick-add-modal")) {
  window.customElements.define("quick-add-modal", QuickAddModal);
}

class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.masterSelect = this.querySelector("[name='id']");
    this.form = this.querySelector("form");
    this.bindEvents();
  }

  bindEvents() {
    this.shouldGoToCheckout = this.getAttribute("data-should-go-to-checkout");
    this.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    this.masterSelect.value = variant.id;
  }

  handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.form);
    const atcButton = this.querySelector("[data-atc-button]");

    formData.set("sections", ["cart-drawer"]);

    if (atcButton) {
      atcButton.classList.add("is-loading");
      atcButton.setAttribute("aria-busy", "true");
    }

    this.dispatchEvent(
      new CustomEvent("cart-loading", {
        bubbles: true,
      })
    );
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (this.shouldGoToCheckout) {
          window.location.href = "/checkout";
        } else {
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            cartDrawer.reloadCart(data.sections["cart-drawer"], true);
          }
        }
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      })
      .finally(() => {
        if (atcButton) {
          atcButton.classList.remove("is-loading");
          atcButton.removeAttribute("aria-busy");
        }
      });
  }
}

if (!window.customElements.get("product-form")) {
  window.customElements.define("product-form", ProductForm);
}

class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const variantsEl = this.querySelector("[data-variants]");
    if (!variantsEl) return;
    this.variants = JSON.parse(variantsEl.textContent).variants;
    this.currentVariant = null;
    this.optionInputs = this.querySelectorAll("input");
    this.bindEvents();
  }

  bindEvents() {
    this.listenToChange();
  }

  listenToChange() {
    this.optionInputs.forEach((input) => {
      input.addEventListener("change", this.updateCurrentVariant.bind(this));
    });
  }
  getSelectedValues() {
    return Array.from(this.querySelectorAll("input:checked")).reduce(
      (acc, input) => {
        acc[input.name] = input.value;
        return acc;
      },
      {}
    );
  }

  updateCurrentVariant() {
    const selectedValues = this.getSelectedValues();

    this.currentVariant =
      this.variants.find((variant) => {
        return Object.entries(selectedValues).every(([name, value]) => {
          return variant[name] === value;
        });
      }) || null;

    if (this.currentVariant) {
      this.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: {
            variant: this.currentVariant,
          },
          bubbles: true,
        })
      );
    }
  }
}

if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}

class HeaderInner extends HTMLElement {
  constructor() {
    super();
    this.closeTimeout = null;
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.header = this.closest("header");
    this.setupMegaMenuTriggers();
    this.setupScrollListener();
  }

  setupScrollListener() {
    let lastScrollY = window.scrollY;

    window.addEventListener("scroll", () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 100) {
        if (currentScrollY > lastScrollY) {
          this.header.classList.add("scrolling-down");
        } else if (currentScrollY < lastScrollY) {
          this.header.classList.remove("scrolling-down");
        }
      } else {
        this.header.classList.remove("scrolling-down");
      }

      lastScrollY = currentScrollY;
    });
  }

  setupMegaMenuTriggers() {
    this.megaMenus = Array.from(this.querySelectorAll("mega-menu"));
    this.addEventListener("mouseleave", this.closeAllMegaMenus.bind(this));
    this.addEventListener("mega-menu:toggle", (e) =>
      this.handleMegaMenuToggle(e)
    );
  }

  handleMegaMenuToggle(event) {
    const active = event.detail.active;
    const title = event.detail.title;
    if (active) {
      this.megaMenus
        .filter((menu) => menu.dataset.megaMenu !== title)
        .forEach((menu) => menu.classList.remove("active"));
    }
  }

  closeAllMegaMenus() {
    this.megaMenus.forEach((menu) => menu.classList.remove("active"));
  }
}

if (!window.customElements.get("header-inner")) {
  window.customElements.define("header-inner", HeaderInner);
}

class MegaMenuWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }
  bindEvents() {
    this.title = this.dataset.title;
    this.megaMenu = this.querySelector("mega-menu");
    this.debounceTimeout = null;
    this.addEventListener("mouseenter", () =>
      this.debouncedToggleMegaMenu(true)
    );
    this.addEventListener("mouseleave", () =>
      this.debouncedToggleMegaMenu(false)
    );
  }

  debouncedToggleMegaMenu(active) {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(
      () => {
        this.toggleMegaMenu(active);
      },
      active ? 0 : 300
    );
  }

  toggleMegaMenu(active) {
    this.megaMenu.classList.toggle("active", active);
    this.dispatchEvent(
      new CustomEvent("mega-menu:toggle", {
        detail: {
          active,
          title: this.title,
        },
        bubbles: true,
      })
    );
  }
}

if (!window.customElements.get("mega-menu-wrapper")) {
  window.customElements.define("mega-menu-wrapper", MegaMenuWrapper);
}

class MegaMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.innerMenus = Array.from(this.querySelectorAll("[data-inner-menu]"));
    this.innerTriggers = Array.from(
      this.querySelectorAll("[data-inner-trigger]")
    );
    this.innerTriggers.forEach((trigger) =>
      trigger.addEventListener("mouseenter", () =>
        this.toggleInnerMenu(trigger, true)
      )
    );
  }

  toggleInnerMenu(trigger, open = true) {
    this.closeAllInnerMenus();
    const innerMenuTitle = trigger.dataset.innerTrigger;
    const innerMenu = this.querySelector(
      `[data-inner-menu="${innerMenuTitle}"]`
    );
    trigger.classList.toggle("active", open);
    if (!innerMenu) return;
    innerMenu.classList.toggle("active", open);
  }

  closeAllInnerMenus() {
    this.innerMenus.forEach((menu) => menu.classList.remove("active"));
    this.innerTriggers.forEach((trigger) => trigger.classList.remove("active"));
  }
}

if (!window.customElements.get("mega-menu")) {
  window.customElements.define("mega-menu", MegaMenu);
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.openButtons = document.querySelectorAll("[data-menu-drawer-open]");
    this.openButtons.forEach((button) =>
      button.addEventListener("click", () => this.toggleOpen(true))
    );
    this.closeButtons = document.querySelectorAll("[data-menu-drawer-close]");
    this.closeButtons.forEach((button) =>
      button.addEventListener("click", () => this.close())
    );
    this.panels = Array.from(this.querySelectorAll("[data-panel]"));
    this.panelTriggers = Array.from(
      this.querySelectorAll("[data-panel-trigger]")
    );
    this.panelTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const panel = this.panels.find(
          (panel) => panel.dataset.panel === trigger.dataset.panelTrigger
        );
        panel.classList.add("active");
      });
    });
    this.closePanels = Array.from(this.querySelectorAll("[data-close-panels]"));
    this.closePanels.forEach((panel) =>
      panel.addEventListener("click", () => this.closeAllPanels())
    );
    this.backButton = this.querySelector("[data-menu-drawer-back]");
    this.backButton?.addEventListener("click", () => this.back());
  }

  close() {
    this.classList.remove("active");
    this.closeAllPanels();
    document.documentElement.classList.remove("no-scroll");
  }

  back() {
    this.panels.forEach((panel) => panel.classList.remove("active"));
  }

  closeAllPanels() {
    this.panels.forEach((panel) => panel.classList.remove("active"));
  }

  toggleOpen(active = true) {
    const bottomOfHeader = document
      .querySelector("header-inner")
      .getBoundingClientRect().bottom;
    this.style.top = `${bottomOfHeader + 8}px`;
    this.classList.toggle("active", active);
    document.documentElement.classList.toggle("no-scroll", active);
  }
}

if (!window.customElements.get("menu-drawer")) {
  window.customElements.define("menu-drawer", MenuDrawer);
}

class ProductPage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.variantInputs = this.querySelectorAll("[name='id']");
    this.subscriptionTexts = Array.from(
      this.querySelectorAll("[data-subscription-text]")
    );
    this.oneTimeTexts = Array.from(
      this.querySelectorAll("[data-one-time-text]")
    );
    this.sellingPlanInputs = Array.from(
      this.querySelectorAll("[name='selling_plan']")
    );
    this.priceElements = Array.from(
      this.querySelectorAll("[data-price-target]")
    );
    this.comparePriceElements = Array.from(
      this.querySelectorAll("[data-compare-price-target]")
    );

    this.addEventListener("variant:change", (e) => {
      this.variantInputs.forEach(
        (input) => (input.value = e.detail.variant.id)
      );
    });

    this.sellingPlanInputs.forEach((input) => {
      input.addEventListener("change", this.handleSellingPlanChange.bind(this));
    });

    this.handleSellingPlanChange();
  }

  handleSellingPlanChange() {
    const selectedSellingPlan = this.sellingPlanInputs.find(
      (input) => input.checked
    );
    const planText = selectedSellingPlan?.dataset.text;
    const price = selectedSellingPlan?.dataset.priceText;
    const comparePrice = selectedSellingPlan?.dataset.comparePriceText;
    const hasSellingPlan =
      selectedSellingPlan && selectedSellingPlan.value !== "";

    this.subscriptionTexts.forEach((text) => {
      text.textContent = planText;
      text.classList.toggle("hidden", !hasSellingPlan);
    });
    this.oneTimeTexts.forEach((text) =>
      text.classList.toggle("hidden", hasSellingPlan)
    );
    this.priceElements.forEach((element) => {
      if (!price) return;
      element.textContent = price;
    });
    this.comparePriceElements.forEach((element) => {
      if (comparePrice) {
        element.textContent = comparePrice;
        element.classList.remove("hidden");
      } else {
        element.classList.add("hidden");
      }
    });
  }
}

if (!window.customElements.get("product-page")) {
  window.customElements.define("product-page", ProductPage);
}

class ProductGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initMainSwiper();
    this.initThumbnails();
  }

  initMainSwiper() {
    const currentNumber = this.querySelector("[data-swiper-number-current]");
    const totalNumber = this.querySelector("[data-swiper-number-total]");
    this.swiper = new Swiper(this.querySelector(".product-gallery__swiper"), {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });

    this.swiper.on("slideChange", () => {
      if (currentNumber) currentNumber.textContent = this.swiper.realIndex + 1;
    });
  }

  initThumbnails() {
    this.thumbnails = this.querySelectorAll("[data-thumbnail]");
    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", () =>
        this.swiper.slideTo(thumbnail.dataset.index)
      );
    });

    this.swiper.on("slideChange", () => {
      this.thumbnails.forEach((thumbnail) => {
        thumbnail.classList.remove("active");
      });
      this.thumbnails[this.swiper.activeIndex].classList.add("active");
    });
  }
}

if (!window.customElements.get("product-gallery")) {
  window.customElements.define("product-gallery", ProductGallery);
}

class ProductInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.variantInput = this.querySelector("[name='id']");
    this.priceElements = this.querySelectorAll("[data-product-price]");
    this.atcButton = this.querySelector("[data-atc-button]");
    this.comparePriceElements = this.querySelectorAll(
      "[data-product-compare-price]"
    );
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.accordions = this.querySelectorAll("details");
    this.setupAccordions();
  }

  setupAccordions() {
    this.accordions.forEach((accordion) => {
      accordion.addEventListener("click", (e) => {
        const clickedAccordion = e.currentTarget;

        this.accordions.forEach((accordion) => {
          if (
            accordion !== clickedAccordion &&
            accordion.hasAttribute("open")
          ) {
            accordion.removeAttribute("open");
          }
        });
      });
    });
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    this.variantInput.value = variant.id;
    updateAllElements(this.priceElements, Shopify.formatMoney(variant.price));
    updateAllElements(this.comparePriceElements, "");
    if (variant.compare_at_price > variant.price) {
      updateAllElements(
        this.comparePriceElements,
        Shopify.formatMoney(variant.compare_at_price)
      );
    }

    this.updateAtcButton(variant);

    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", url);
  }

  updateAtcButton(variant) {
    if (variant.available) {
      this.atcButton.removeAttribute("disabled");
      this.atcButton.classList.remove("opacity-50");
      this.atcButton.textContent = "Add to Cart";
    } else {
      this.atcButton.setAttribute("disabled", "");
      this.atcButton.classList.add("opacity-50");
      this.atcButton.textContent = "Sold Out";
    }
  }
}

if (!window.customElements.get("product-info")) {
  window.customElements.define("product-info", ProductInfo);
}

class SellingPlanSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.subscriptionPill = this.querySelector("[data-subscription-pill]");
    this.subscriptionPriceEl = this.querySelector("[data-subscription-price]");
    this.subscriptionComparePriceEl = this.querySelector("[data-subscription-compare-price]");
    this.oneTimePriceEl = this.querySelector("[data-one-time-price]");
    this.oneTimeComparePriceEl = this.querySelector("[data-one-time-compare-price]");
    this.discountPercent = parseFloat(this.subscriptionPill?.dataset.discountPercent) || 0;

    if (this.subscriptionPill) {
      this.subscriptionPill.addEventListener(
        "click",
        this.handleSubscriptionPillClick.bind(this)
      );
    }

    // Listen on closest product-page ancestor or document for variant:change events
    const productPage = this.closest("product-page");
    if (productPage) {
      productPage.addEventListener("variant:change", this.handleVariantChange.bind(this));
    }
  }

  handleSubscriptionPillClick(event) {
    const input = this.subscriptionPill.querySelector("input");
    if (input && !event.target.closest("[data-dropdown-content]")) {
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    if (!variant) return;

    const price = variant.price;
    const compareAtPrice = variant.compare_at_price;

    // Update one-time prices
    if (this.oneTimePriceEl) {
      this.oneTimePriceEl.textContent = Shopify.formatMoney(price);
    }
    if (this.oneTimeComparePriceEl) {
      if (compareAtPrice && compareAtPrice > price) {
        this.oneTimeComparePriceEl.textContent = Shopify.formatMoney(compareAtPrice);
        this.oneTimeComparePriceEl.classList.remove('hidden');
      } else {
        this.oneTimeComparePriceEl.classList.add('hidden');
      }
    }

    // Update subscription prices
    if (this.subscriptionComparePriceEl) {
      this.subscriptionComparePriceEl.textContent = Shopify.formatMoney(price);
    }
    if (this.subscriptionPriceEl && this.discountPercent) {
      const discountedPrice = price * (1 - this.discountPercent / 100);
      this.subscriptionPriceEl.textContent = Shopify.formatMoney(discountedPrice);
    }

    // Update data attributes on selling plan inputs for handleSellingPlanChange
    const sellingPlanInputs = this.querySelectorAll("[name='selling_plan']");
    sellingPlanInputs.forEach((input) => {
      if (input.value === "") {
        // One-time purchase
        input.dataset.priceText = Shopify.formatMoney(price);
        input.dataset.comparePriceText = compareAtPrice ? Shopify.formatMoney(compareAtPrice) : "";
      } else {
        // Subscription
        const discountedPrice = price * (1 - this.discountPercent / 100);
        input.dataset.priceText = Shopify.formatMoney(discountedPrice);
        input.dataset.comparePriceText = Shopify.formatMoney(price);
      }
    });
  }
}

if (!window.customElements.get("selling-plan-selector")) {
  window.customElements.define("selling-plan-selector", SellingPlanSelector);
}

function updateAllElements(elements, value) {
  elements.forEach((element) => {
    element.textContent = value;
  });
}

class EchoDropdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.trigger = this.querySelector("button");
    this.content = this.querySelector("[data-dropdown-content]");
    this.mobilePopup = this.querySelector("[data-mobile-popup]");
    this.items = this.querySelectorAll("[data-dropdown-item]");
    this.bindEvents();
  }

  bindEvents() {
    this.trigger.addEventListener("click", this.toggleOpen.bind(this));
    document.addEventListener("click", this.handleClickOutside.bind(this));
    this.items.forEach((item) => {
      item.addEventListener("change", this.handleItemChange.bind(this));
    });
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.content.classList.remove("active");
      this.mobilePopup?.classList.remove("active");
    }
  }

  toggleOpen(event, open = true) {
    event.stopPropagation();
    this.content.classList.toggle("active", open);
    this.mobilePopup?.classList.toggle("active", open);
  }

  handleItemChange(event) {
    const item = event.target;
    const value = item.value;
    const text = item.dataset.text || value;
    this.trigger.textContent = text;
    this.toggleOpen(event, false);
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: {
          value: value,
          text: text,
        },
        bubbles: true,
      })
    );
  }
}

if (!window.customElements.get("echo-dropdown")) {
  window.customElements.define("echo-dropdown", EchoDropdown);
}
class MobilePopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.overlay = this.querySelector("[data-mobile-popup-overlay]");
    this.overlay.addEventListener("click", () => {
      this.close();
    });
  }

  close() {
    this.classList.remove("active");
  }

  open() {
    this.classList.add("active");
  }
}

if (!window.customElements.get("mobile-popup")) {
  window.customElements.define("mobile-popup", MobilePopup);
}

class ScrollSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    window.addEventListener("resize", this.init.bind(this));
  }

  init() {
    this.bindEvents();
    this.calculateHeight();
  }

  bindEvents() {
    this.scrollBlocks = Array.from(
      this.querySelectorAll("[data-scroll-block]")
    );
    document.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    const scrollPosition = window.scrollY;
    const sectionTop = this.offsetTop;
    const sectionHeight = this.offsetHeight;
    const scrollProgress = (scrollPosition - sectionTop) / sectionHeight;

    const isMobile = window.innerWidth <= 767;
    const threshold = isMobile ? -0.05 : 0;
    this.classList.toggle("active", scrollProgress > threshold);

    //handle blocks
    this.scrollBlocks.forEach((block, index) => {
      const blockProgress = index / this.scrollBlocks.length;
      const blockStart = blockProgress - 0.2;
      const blockEnd = blockProgress + 0.2;

      let opacity;
      if (scrollProgress < blockStart) {
        opacity = 0;
      } else if (scrollProgress > blockEnd) {
        opacity = 0;
      } else if (scrollProgress < blockEnd && index == 0) {
        opacity = 1;
      } else {
        opacity = 1 - Math.abs((scrollProgress - blockProgress) / 0.2);
      }

      opacity = Math.max(0, Math.min(1, opacity));
      block.style.opacity = opacity;

      if (opacity > 0.5) {
        block.classList.add("active");
      } else {
        block.classList.remove("active");
      }
    });
  }

  calculateHeight() {
    const height = this.scrollBlocks.length * window.innerHeight;
    this.style.height = `${height}px`;
    this.classList.add("is-initialised");
  }
}

if (!window.customElements.get("scroll-section")) {
  window.customElements.define("scroll-section", ScrollSection);
}

class InfoTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.tabs = this.querySelectorAll("[data-tab-id]");
    this.tabTriggers = this.querySelectorAll("[data-tab-trigger]");
    this.tabTriggers.forEach((tabTrigger) => {
      tabTrigger.addEventListener("click", () => {
        this.toggleTab(tabTrigger.dataset.tabTrigger);
      });
    });
  }

  toggleTab(tabTriggerValue) {
    this.tabTriggers.forEach((c) =>
      c.classList.toggle("active", c.dataset.tabTrigger === tabTriggerValue)
    );
    this.tabs.forEach((tab) =>
      tab.classList.toggle("active", tab.dataset.tabId === tabTriggerValue)
    );
  }
}

if (!window.customElements.get("info-tabs")) {
  window.customElements.define("info-tabs", InfoTabs);
}

class InfoTabSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slidesPerViewDesktop = this.getAttribute(
      "data-slides-per-view-desktop"
    );
    this.slidesPerViewMobile = this.getAttribute("data-slides-per-view-mobile");
    this.init();
  }

  init() {
    this.swiper = new Swiper(this, {
      slidesPerView: this.slidesPerViewMobile,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewDesktop,
          spaceBetween: 28,
        },
      },
    });
  }
}

if (!window.customElements.get("info-tab-swiper")) {
  window.customElements.define("info-tab-swiper", InfoTabSwiper);
}

class ExpandableMultiblock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", this.toggleOpen.bind(this));

    if (window.innerWidth > 768) {
      this.addEventListener("mouseenter", this.setOpen.bind(this, true));
      this.addEventListener("mouseleave", this.setOpen.bind(this, false));
    }
  }

  toggleOpen() {
    this.classList.toggle("active");
  }

  setOpen(open = true) {
    this.classList.toggle("active", open);
  }
}

if (!window.customElements.get("expandable-multiblock")) {
  window.customElements.define("expandable-multiblock", ExpandableMultiblock);
}

class YoutubeBlogs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    const loadMoreButton = this.querySelector("[data-load-more]");
    if (loadMoreButton) {
      loadMoreButton.addEventListener("click", this.loadMore.bind(this));
    }
  }

  loadMore() {
    const hiddenItems = this.querySelectorAll(".hidden.md\\:flex");
    const loadMoreButton = this.querySelector("[data-load-more]");

    for (let i = 0; i < 3 && i < hiddenItems.length; i++) {
      hiddenItems[i].classList.remove("hidden");
    }

    if (hiddenItems.length <= 3) {
      loadMoreButton.style.display = "none";
    }
  }
}

if (!window.customElements.get("youtube-blogs")) {
  window.customElements.define("youtube-blogs", YoutubeBlogs);
}

class UpcomingEvents extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadMoreButton = this.querySelector("[data-load-more]");
    this.loadMoreText = this.querySelector("[data-load-more-text]");
    this.loadLessText = this.querySelector("[data-load-less-text]");
    this.expanded = false;
    this.lazyEvents = this.querySelectorAll(".lazy-event");
    if (this.loadMoreButton) this.loadMoreButton.addEventListener("click", this.toggleEvents.bind(this));
  }

  toggleEvents() {
    this.expanded = !this.expanded;
    this.lazyEvents.forEach((event) =>
      event.classList.toggle("hidden", !this.expanded)
    );

    this.loadMoreText.classList.toggle("hidden", this.expanded);
    this.loadLessText.classList.toggle("hidden", !this.expanded);
  }
}

if (!window.customElements.get("upcoming-events")) {
  window.customElements.define("upcoming-events", UpcomingEvents);
}

class BlogSection1 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  }
}

if (!window.customElements.get("blog-section-1")) {
  window.customElements.define("blog-section-1", BlogSection1);
}

class OurMissionSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 3.2,
        },
      },
    });
  }
}

if (!window.customElements.get("our-mission-slider")) {
  window.customElements.define("our-mission-slider", OurMissionSlider);
}

class InTheNews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.swiper = new Swiper(this, {
      spaceBetween: 36,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      grid: {
        rows: 2,
        columns: 1,
        fill: "row",
      },
      slidesPerView: 1,
      breakpoints: {
        768: {
          grid: {
            rows: 2,
            columns: 3,
            fill: "row",
          },
          slidesPerView: 3,
        },
      },
    });
  }
}

if (!window.customElements.get("in-the-news")) {
  window.customElements.define("in-the-news", InTheNews);
}

class OverviewSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
    });
  }
}

if (!window.customElements.get("overview-slider")) {
  window.customElements.define("overview-slider", OverviewSlider);
}

class TechSpecsHero extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.blocks = Array.from(this.querySelectorAll("[data-tech-spec-block]"));
    this.headings = Array.from(
      this.querySelectorAll("[data-tech-spec-heading]")
    );

    document.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    let activeHeading = this.blocks[0].dataset.techSpecBlock;
    this.blocks.forEach((block) => {
      const blockTop = block.offsetTop;
      const scrollPosition = window.scrollY;

      if (scrollPosition >= blockTop - 100) {
        activeHeading = block.dataset.techSpecBlock;
      }
    });

    this.headings.forEach((heading) =>
      heading.classList.toggle(
        "active",
        heading.dataset.techSpecHeading === activeHeading
      )
    );
  }
}

if (!window.customElements.get("tech-specs-hero")) {
  window.customElements.define("tech-specs-hero", TechSpecsHero);
}

class StickyAtc extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.atcButton =
      document.querySelector("[data-atc-button]") ||
      this.querySelector("[data-atc-button]");
    this.bindEvents();
    this.handleScroll();
  }

  bindEvents() {
    document.addEventListener("scroll", this.handleScroll.bind(this));
    window.addEventListener("resize", this.handleScroll.bind(this));
  }

  handleScroll() {
    if (!this.atcButton) return;
    const buttonRect = this.atcButton.getBoundingClientRect();
    const isOffTop = buttonRect.bottom < 0;
    this.classList.toggle("active", isOffTop);
  }
}

if (!window.customElements.get("sticky-atc")) {
  window.customElements.define("sticky-atc", StickyAtc);
}

class TakeChargeSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 10,
      loop: true,
      slidesOffsetBefore: -120,
      navigation: {
        nextEl: this.parentElement.querySelector(".next"),
        prevEl: this.parentElement.querySelector(".prev"),
      },
      breakpoints: {
        1024: {
          slidesOffsetBefore: 0,
          navigation: {
            nextEl: this.parentElement.querySelector(".prev"),
            prevEl: this.parentElement.querySelector(".next"),
          },
        },
      },
    });
  }
}

if (!window.customElements.get("take-charge-slider")) {
  window.customElements.define("take-charge-slider", TakeChargeSlider);
}

class PremiumFeaturesSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      slidesOffsetBefore: 20,
      navigation: {
        nextEl: this.parentElement.querySelector(".next"),
        prevEl: this.parentElement.querySelector(".prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesOffsetBefore: 0,
          navigation: {
            nextEl: this.parentElement.querySelector(".prev"),
            prevEl: this.parentElement.querySelector(".next"),
          },
        },
      },
    });
  }
}

if (!window.customElements.get("premium-features-slider")) {
  window.customElements.define(
    "premium-features-slider",
    PremiumFeaturesSlider
  );
}

class SupplementReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 32,
      loop: true,
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },
    });
  }
}

if (!window.customElements.get("supplement-reviews")) {
  window.customElements.define("supplement-reviews", SupplementReviews);
}

class WhwfColumns extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.numberOfColumns = this.getAttribute("data-columns");
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: this.parentElement.querySelector(".next"),
        prevEl: this.parentElement.querySelector(".prev"),
      },
      breakpoints: {
        1024: {
          slidesPerView: this.numberOfColumns,
        },
      },
    });
  }
}

if (!window.customElements.get("whwf-columns")) {
  window.customElements.define("whwf-columns", WhwfColumns);
}

class ReadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.preview = this.querySelector("[data-preview]");
    this.fullText = this.querySelector("[data-full-text]");
    this.toggleButton = this.querySelector("[data-toggle-button]");
    this.readMoreText = this.toggleButton.dataset.readMore;
    this.readLessText = this.toggleButton.dataset.readLess;
    this.isExpanded = false;

    // Initially hide the full text and show the preview
    if (this.fullText) this.fullText.style.display = "none";
    if (this.preview) this.preview.style.display = "inline"; // Or 'block'/'inline-block' depending on context
    this.toggleButton.textContent = this.readMoreText;

    this.toggleButton.addEventListener("click", this.toggle.bind(this));
  }

  toggle() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      if (this.preview) this.preview.style.display = "none";
      if (this.fullText) this.fullText.style.display = "inline"; // Or 'block'/'inline-block'
      this.toggleButton.textContent = this.readLessText;
    } else {
      if (this.preview) this.preview.style.display = "inline"; // Or 'block'/'inline-block'
      if (this.fullText) this.fullText.style.display = "none";
      this.toggleButton.textContent = this.readMoreText;
    }
  }
}

if (!window.customElements.get("read-more")) {
  window.customElements.define("read-more", ReadMore);
}

class LogoCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 2,
      spaceBetween: 10,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 6,
        },
      },
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
    });
  }
}

if (!window.customElements.get("logo-carousel")) {
  window.customElements.define("logo-carousel", LogoCarousel);
}

class IconsAndText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.desktopSlides = this.getAttribute("data-desktop-slides");
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 40,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: this.desktopSlides,
          autoplay: false,
          spaceBetween: 10,
        },
      },
    });
  }
}

if (!window.customElements.get("icons-and-text")) {
  window.customElements.define("icons-and-text", IconsAndText);
}

class AtcBlockButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const productPage = document.querySelector("product-page");
    if (productPage) {
      this.addEventListener("click", () => {
        productPage.querySelector("button[type='submit']").click();
      });
    }
  }
}

if (!window.customElements.get("atc-block-button")) {
  window.customElements.define("atc-block-button", AtcBlockButton);
}

class CertificationCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 20,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    });
  }
}

if (!window.customElements.get("certification-carousel")) {
  window.customElements.define("certification-carousel", CertificationCarousel);
}

class FeelBetterSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: true,
      slidesOffsetAfter: 20,
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
    });
  }
}

if (!window.customElements.get("feel-better-slider")) {
  window.customElements.define("feel-better-slider", FeelBetterSlider);
}

class FlaskLogoCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.autoplayDelay = this.getAttribute("data-autoplay-delay");
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 40,
      loop: true,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      autoplay: {
        delay: this.autoplayDelay * 1000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          spaceBetween: 0,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });
  }
}

if (!window.customElements.get("flask-logo-carousel")) {
  window.customElements.define("flask-logo-carousel", FlaskLogoCarousel);
}

class VideoCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this, {
      slidesPerView: 1.5,
      centeredSlides: true,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          loop: false,
          slidesPerView: this.getAttribute("data-slides"),
          centeredSlides: false,
        },
      },
    });
  }
}

if (!window.customElements.get("video-carousel")) {
  window.customElements.define("video-carousel", VideoCarousel);
}

class WhyHydrogenSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  }
}

if (!window.customElements.get("why-hydrogen-swiper")) {
  window.customElements.define("why-hydrogen-swiper", WhyHydrogenSwiper);
}
class WhyHydrogenAccordions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.accordions = this.querySelectorAll("details");
    this.bindEvents();
  }

  bindEvents() {
    this.accordions.forEach((accordion) => {
      accordion.addEventListener("click", (e) => {
        const clickedAccordion = e.currentTarget;

        this.accordions.forEach((accordion) => {
          if (
            accordion !== clickedAccordion &&
            accordion.hasAttribute("open")
          ) {
            accordion.removeAttribute("open");
          }
        });
      });
    });
  }
}

if (!window.customElements.get("why-hydrogen-accordions")) {
  window.customElements.define(
    "why-hydrogen-accordions",
    WhyHydrogenAccordions
  );
}

class FlaskBuzzSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      loop: true,
      centeredSlides: true,
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  }
}

if (!window.customElements.get("flask-buzz-swiper")) {
  window.customElements.define("flask-buzz-swiper", FlaskBuzzSwiper);
}

class HoverVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.video = this.querySelector("video");
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("mouseenter", this.playVideo.bind(this));
    this.addEventListener("mouseleave", this.pauseVideo.bind(this));
  }

  playVideo() {
    if (this.video) this.video.play().catch(() => {});
  }

  pauseVideo() {
    if (this.video) this.video.pause();
  }
}

if (!window.customElements.get("hover-video")) {
  window.customElements.define("hover-video", HoverVideo);
}

class ClickVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.video = this.querySelector("video");
    this.playButton = document.createElement("div");
    this.playButton.className = "click-video-play-button";
    this.playButton.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5.14V19.14L19 12.14L8 5.14Z" fill="white"/>
        </svg>
      `;
    this.appendChild(this.playButton);
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", this.toggleVideo.bind(this));
  }

  toggleVideo() {
    if (this.video.paused) {
      document.querySelectorAll("video").forEach((video) => video.pause());
      document
        .querySelectorAll("click-video")
        .forEach((video) => video.classList.add("paused"));
      this.video.play();
    } else {
      this.video.pause();
    }
    this.classList.toggle("paused", this.video.paused);
  }
}

if (!window.customElements.get("click-video")) {
  window.customElements.define("click-video", ClickVideo);
}

class ProductReviewStars extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", () => {
      const reviewWidget = document.querySelector("[data-oke-widget]");
      if (reviewWidget) {
        reviewWidget.scrollIntoView({ behavior: "smooth" });
      }
    });
  }
}

if (!window.customElements.get("product-review-stars")) {
  window.customElements.define("product-review-stars", ProductReviewStars);
}

class ProductIconsWithText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 2,
      spaceBetween: 12,
      loop: true,
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: this.getAttribute("data-number-of-icons"),
          loop: false,
          spaceBetween: 24,
        },
      },
    });
  }
}

if (!window.customElements.get("product-icons-with-text")) {
  window.customElements.define("product-icons-with-text", ProductIconsWithText);
}

class WhatsIncludedSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.totalSlides = this.getAttribute("data-total-slides");
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: true,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: this.totalSlides,
          loop: false,
          centeredSlides: false,
        },
      },
    });
  }
}

if (!window.customElements.get("whats-included-slider")) {
  window.customElements.define("whats-included-slider", WhatsIncludedSlider);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.cartButton = document.querySelectorAll("[data-cart-btn]");
    this.cartButton.forEach((button) =>
      button.addEventListener("click", () => this.openCartDrawer())
    );
    this.closeButton = document.querySelector("[data-close-cart-drawer]");
    if (this.closeButton) this.closeButton.addEventListener("click", () => this.closeCartDrawer());
    this.pageOverlay = document.querySelector(".cart-drawer-overlay");
    if (this.pageOverlay) {
      this.pageOverlay.addEventListener("click", () => this.closeCartDrawer());
    }
    this.addEventListener("quantity-change", this.onQuantityChange);

    this.querySelectorAll("[data-remove-from-cart]").forEach((button) =>
      button.addEventListener("click", this.onRemoveFromCart.bind(this))
    );

    this.toggleLoading = this.toggleLoading.bind(this);
    this.addEventListener("cart-loading", this.toggleLoading);
    this.toggleLoading(false);

    if (window.location.search.includes("openCart=true")) {
      this.openCartDrawer();
    }
  }

  toggleLoading(show) {
    this.classList.toggle("loading", show);
  }

  openCartDrawer() {
    this.classList.add("open");
    document.body.classList.add("cart-drawer-open");
    document.querySelector(".cart-drawer-overlay")?.classList.add("open");
  }

  closeCartDrawer() {
    this.classList.remove("open");
    document.body.classList.remove("cart-drawer-open");
    document.querySelector(".cart-drawer-overlay")?.classList.remove("open");
  }

  reloadCart(html = null, open = false) {
    if (html) {
      this.updateContent(html);
    } else {
      fetch("?section_id=cart-drawer")
        .then((response) => response.text())
        .then((res) => this.updateContent(res))
        .catch((err) => console.error("Cart drawer reload failed:", err));
    }
    initCartUpsellDragScroll(this);
    if (open) {
      this.openCartDrawer();
    }
  }

  updateContent(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    this.innerHTML = doc.querySelector("cart-drawer").innerHTML;
    this.init();
    this.updateCartCount();
  }

  updateCartCount() {
    const cartCountText = document.querySelector("[data-cart-count-text]");
    const cartCountTarget = document.querySelector("#cart-count-target");
    if (cartCountText && cartCountTarget) {
      cartCountText.textContent = `(${cartCountTarget.textContent})`;
    }
  }

  onQuantityChange(event) {
    const { lineItemId, quantity } = event.detail;

    const updates = {
      [lineItemId]: quantity,
    };

    this.dispatchEvent(
      new CustomEvent("cart-loading", { detail: { show: true }, bubbles: true })
    );

    fetch(`/cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    }).then(() => this.reloadCart()).catch(() => this.reloadCart());
  }

  onRemoveFromCart(event) {
    this.dispatchEvent(
      new CustomEvent("cart-loading", { detail: { show: true }, bubbles: true })
    );
    const lineItemKey = event.target.dataset.removeFromCart;
    fetch(`/cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
    }).then(() => this.reloadCart()).catch(() => this.reloadCart());
  }
}

if (!window.customElements.get("cart-drawer")) {
  window.customElements.define("cart-drawer", CartDrawer);
}

class CartProgress extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.currency = this.dataset.currency;
    this.totalPrice = Number(this.dataset.totalPrice);
    this.shippingThresholdInUSD = this.dataset.shippingThreshold;
    this.currencySymbol = this.dataset.currencySymbol;
    if (this.currency === "USD") return;

    const shippingThreshold = Number(
      Currency.convert(
        this.shippingThresholdInUSD,
        "USD",
        this.currency
      ).toFixed(2)
    );

    if (this.querySelector("[data-amount-to-free-shipping]")) {
      this.querySelector("[data-amount-to-free-shipping]").textContent =
        Shopify.formatMoney(
          shippingThreshold - this.totalPrice,
          this.currencySymbol + "{{amount}}"
        );
    }
  }
}

if (!window.customElements.get("cart-progress")) {
  window.customElements.define("cart-progress", CartProgress);
}

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.quantityInput = this.querySelector("[data-quantity-input]");
    this.decreaseButton = this.querySelector("[data-decrease-quantity]");
    this.increaseButton = this.querySelector("[data-increase-quantity]");
    this.quantity = parseInt(this.dataset.quantity);
    this.decreaseButton.addEventListener(
      "click",
      this.onDecreaseQuantity.bind(this)
    );
    this.increaseButton.addEventListener(
      "click",
      this.onIncreaseQuantity.bind(this)
    );
  }

  connectedCallback() {
    this.init();
  }

  onDecreaseQuantity() {
    if (this.quantity <= 0) return;

    // If quantity is 1, "trash" should remove item (set to 0)
    if (this.quantity === 1) {
      this.quantity = 0;
      this.onQuantityChange();
      return;
    }

    // Otherwise behave like normal decrement
    this.quantity--;
    this.onQuantityChange();
  }

  onIncreaseQuantity() {
    this.quantity++;
    this.onQuantityChange();
  }

  onQuantityChange() {
    this.quantityInput.textContent = this.quantity;
    this.dispatchEvent(
      new CustomEvent("quantity-change", {
        detail: {
          lineItemId: this.dataset.lineItemId,
          quantity: this.quantity,
        },
        bubbles: true,
      })
    );
  }
}

if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}

class AccordionGroup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.accordions = this.querySelectorAll("details");
    this.bindEvents();
  }

  bindEvents() {
    this.accordions.forEach((accordion) => {
      accordion.addEventListener("click", (e) => {
        const clickedAccordion = e.currentTarget;

        this.accordions.forEach((accordion) => {
          if (
            accordion !== clickedAccordion &&
            accordion.hasAttribute("open")
          ) {
            accordion.removeAttribute("open");
          }
        });
      });
    });
  }
}

if (!window.customElements.get("accordion-group")) {
  window.customElements.define("accordion-group", AccordionGroup);
}

class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.debounceTimeout = null;
    this.searchInput = null;
    this.searchResults = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.searchButton = document.querySelectorAll("[data-search-btn]");
    this.searchButton.forEach((button) =>
      button.addEventListener("click", () => this.openDrawer())
    );
    this.searchDrawerClose = this.querySelectorAll(
      "[data-search-drawer-close]"
    );
    this.searchDrawerClose.forEach((button) =>
      button.addEventListener("click", () => this.closeDrawer())
    );
    this.pageOverlay = document.querySelector(".search-drawer-overlay");
    if (this.pageOverlay) this.pageOverlay.addEventListener("click", () => this.closeDrawer());

    this.searchInput = this.querySelector("[data-search-input]");
    this.searchResults = this.querySelector("[data-search-results]");
    this.form = this.querySelector("[data-search-drawer-form]");

    if (this.searchInput) {
      this.searchInput.addEventListener(
        "input",
        this.handleSearchInput.bind(this)
      );
    }

    this.form.addEventListener("reset", () => {
      this.searchResults.innerHTML = '<div class="contents"></div>';
      this.searchInput.value = "";
    });
  }

  handleSearchInput(event) {
    const query = event.target.value.trim();

    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    if (!query) {
      this.searchResults.innerHTML = '<div class="contents"></div>';
      return;
    }

    this.debounceTimeout = setTimeout(() => {
      this.performSearch(query);
    }, 300);
  }

  async performSearch(query) {
    try {
      const url = `${routes.predictive_search_url}?q=${encodeURIComponent(
        query
      )}&resources[limit_scope]=each&section_id=search-drawer`;

      const response = await fetch(url);
      const data = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      this.searchResults.innerHTML = doc
        .querySelector("search-drawer")
        .querySelector("[data-search-results]").innerHTML;

      this.initResults();
    } catch (error) {
      console.error("Search error:", error);
      this.searchResults.innerHTML =
        '<div class="contents">Error loading search results.</div>';
    }
  }

  openDrawer() {
    this.classList.add("open");
  }

  closeDrawer() {
    this.classList.remove("open");
  }

  initResults() {
    const triggers = this.querySelectorAll("[data-resource-trigger]");
    const targets = this.querySelectorAll("[data-resource-target]");

    targets.length > 0 && targets[0].classList.remove("hidden");
    triggers.length > 0 && triggers[0].classList.remove("opacity-50");

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        targets.forEach((target) =>
          target.classList.toggle(
            "hidden",
            target.dataset.resourceTarget !== trigger.dataset.resourceTrigger
          )
        );
        triggers.forEach((t) => t.classList.toggle("opacity-50", t != trigger));
      });
    });
  }
}

if (!window.customElements.get("search-drawer")) {
  window.customElements.define("search-drawer", SearchDrawer);
}

class WebinarCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const timeData = this.getAttribute("js-countdown-data");
    const jsonTimeData = JSON.parse(timeData);
    const starttime = jsonTimeData.starttime;
    const endtime = jsonTimeData.endtime;
    const daysEl = this.querySelector("[data-days]");
    const hoursEl = this.querySelector("[data-hours]");
    const minutesEl = this.querySelector("[data-minutes]");
    const secondsEl = this.querySelector("[data-seconds]");
    const countdownEl = this;

    function addZero(value) {
      if (value < 10) {
        return "0" + value;
      } else {
        return value;
      }
    }

    if (endtime.length > 0) {
      const countDownDate = new Date(endtime).getTime();
      const startDate = new Date(starttime).getTime();
      const checker = setInterval(function () {
        const now = new Date().getTime();

        if (now >= countDownDate) {
          clearInterval(checker);
          daysEl.innerText = "00";
          hoursEl.innerText = "00";
          minutesEl.innerText = "00";
          secondsEl.innerText = "00";
          countdownEl.classList.remove("hidden");
        } else if (now < startDate) {
          countdownEl.classList.add("hidden");
        } else {
          countdownEl.classList.remove("hidden");
          let distance = countDownDate - now;

          if (startDate > now) {
            distance = countDownDate - startDate;
          }

          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          days = addZero(days);

          let hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          hours = addZero(hours);

          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          minutes = addZero(minutes);

          let seconds = Math.floor((distance % (1000 * 60)) / 1000);
          seconds = addZero(seconds);

          daysEl.innerText = days;
          hoursEl.innerText = hours;
          minutesEl.innerText = minutes;
          secondsEl.innerText = seconds;

          if (distance < 0) {
            clearInterval(checker);
          }
        }
      }, 1000);
    }
  }
}

if (!window.customElements.get("webinar-countdown")) {
  window.customElements.define("webinar-countdown", WebinarCountdown);
}

class CollectionPage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.collectionUrl = this.dataset.collectionUrl;
    this.collectionGrid = this.querySelector("collection-grid");
    this.addEventListener("sort-change", (event) => {
      this.updateUrl(event.detail.value);
      this.refresh();
    });
  }

  updateUrl(value) {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", value);
    window.history.pushState({}, "", url);
  }

  refresh() {
    const currentUrl = new URL(window.location.href);
    const sortBy = currentUrl.searchParams.get("sort_by");
    this.collectionGrid.classList.add("loading");
    fetch(`${this.collectionUrl}?sort_by=${sortBy}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newCollectionGrid = doc.querySelector("collection-grid");
        if (newCollectionGrid) this.collectionGrid.innerHTML = newCollectionGrid.innerHTML;
      })
      .finally(() => this.collectionGrid.classList.remove("loading"));
  }
}

if (!window.customElements.get("collection-page")) {
  window.customElements.define("collection-page", CollectionPage);
}

class CollectionSort extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    const openTrigger = this.querySelector("[data-open-trigger]");
    if (openTrigger) openTrigger.addEventListener("click", () => {
      this.classList.toggle("open");
    });

    this.querySelectorAll("[data-value]").forEach((option) => {
      option.addEventListener("click", () => {
        this.dispatchEvent(
          new CustomEvent("sort-change", {
            detail: {
              value: option.dataset.value,
            },
            bubbles: true,
          })
        );
        this.classList.remove("open");
      });
    });
  }
}

if (!window.customElements.get("collection-sort")) {
  window.customElements.define("collection-sort", CollectionSort);
}

class WhyHydrogenVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.video = this.querySelector("video");
    this.playTrigger = this.querySelector("[data-play-trigger]");

    if (this.playTrigger && this.video) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.playTrigger.addEventListener("click", this.handlePlayClick.bind(this));
    this.video.addEventListener("click", this.handleVideoClick.bind(this));
  }

  handlePlayClick() {
    this.playTrigger.classList.add("hidden");
    this.video.play();
  }

  handleVideoClick() {
    if (!this.video.paused) {
      this.video.pause();
      this.playTrigger.classList.remove("hidden");
    }
  }
}

if (!window.customElements.get("why-hydrogen-video")) {
  window.customElements.define("why-hydrogen-video", WhyHydrogenVideo);
}

class LearnMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", this.toggle.bind(this));
  }

  toggle() {
    this.classList.toggle("active");
  }
}

if (!window.customElements.get("learn-more")) {
  window.customElements.define("learn-more", LearnMore);
}

/*
class LottieAnimation extends HTMLElement {
  constructor() {
    super();
    this.animation = null;
    this.hasPlayed = false;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    const animationUrl = this.dataset.animationUrl;

    if (animationUrl && typeof lottie !== "undefined") {
      this.animation = lottie.loadAnimation({
        container: this,
        renderer: "svg",
        loop: true,
        autoplay: false,
        path: animationUrl,
      });

      this.setupIntersectionObserver();
    }
  }

  setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasPlayed) {
            this.playAnimation();
            this.hasPlayed = true;
            observer.unobserve(this);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    observer.observe(this);
  }

  playAnimation() {
    if (this.animation) {
      this.animation.play();
    }
  }
}

if (!window.customElements.get("lottie-animation")) {
  window.customElements.define("lottie-animation", LottieAnimation);
}
*/

class BlurInText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.setupIntersectionObserver();
  }

  setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true;
            this.classList.add("active");
            observer.unobserve(this);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );
    observer.observe(this);
  }
}

if (!window.customElements.get("blur-in-text")) {
  window.customElements.define("blur-in-text", BlurInText);
}

class ClarityFAQs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.triggers = Array.from(this.querySelectorAll("[data-faq-trigger]"));
    this.faqs = Array.from(this.querySelectorAll("[data-faq-category]"));
    this.showMore = this.querySelector("[data-see-more-faqs]");
    this.showLess = this.querySelector("[data-show-less-faqs]");
    this.showingMore = false;

    // Check if we have any triggers
    if (this.triggers.length === 0) {
      console.warn("No FAQ triggers found!");
      return;
    }

    this.sortFAQs();
    this.bindEvents();
    this.setActiveTrigger();
    this.hideExcessFAQs();

    // Mark as initialized
    this.initialized = true;
  }

  setActiveTrigger() {
    this.triggers.forEach((trigger) => {
      trigger.classList.remove("active");
    });

    this.triggers.forEach((trigger) => {
      if (trigger.dataset.faqTrigger === this.selectedCategory) {
        trigger.classList.add("active");
      }
    });
  }

  bindEvents() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        if (this.selectedCategory === trigger.dataset.faqTrigger) {
          return;
        }
        this.selectedCategory = trigger.dataset.faqTrigger;
        this.setAttribute("data-selected-category", this.selectedCategory);
        this.sortFAQs();
        this.setActiveTrigger();
        if (!this.showingMore) {
          this.hideExcessFAQs();
        }
      });
    });

    if (this.showMore) {
      this.showMore.addEventListener("click", () => {
        this.showMoreFAQs();
      });
    }

    if (this.showLess) {
      this.showLess.addEventListener("click", () => {
        this.showLessFAQs();
      });
    }
  }

  sortFAQs() {
    this.selectedCategory = this.getAttribute("data-selected-category");

    this.faqs.sort((a, b) => {
      const aMatches = a.dataset.faqCategory === this.selectedCategory;
      const bMatches = b.dataset.faqCategory === this.selectedCategory;

      if (aMatches && !bMatches) return -1;
      if (!aMatches && bMatches) return 1;
      return 0;
    });

    this.faqs.forEach((faq, index) => {
      faq.style.order = index;
    });
  }

  hideExcessFAQs() {
    const excessFAQs = this.faqs.slice(6);
    this.faqs.forEach((faq) => {
      faq.classList.remove("hidden");
    });
    excessFAQs.forEach((faq) => {
      faq.classList.add("hidden");
    });
  }

  showMoreFAQs() {
    this.showingMore = true;
    this.showMore.classList.toggle("hidden");
    this.showLess.classList.toggle("hidden");

    this.faqs.forEach((faq) => faq.classList.remove("hidden"));
  }

  showLessFAQs() {
    this.showingMore = false;
    this.showMore.classList.toggle("hidden");
    this.showLess.classList.toggle("hidden");

    this.faqs.forEach((faq) => faq.classList.add("hidden"));
    this.faqs.slice(0, 6).forEach((faq) => faq.classList.remove("hidden"));
  }
}

// Ensure the custom element is defined
if (!window.customElements.get("clarity-faqs")) {
  window.customElements.define("clarity-faqs", ClarityFAQs);
}

// Fallback initialization for existing elements
document.addEventListener("DOMContentLoaded", function () {
  const clarityFAQsElements = document.querySelectorAll("clarity-faqs");

  clarityFAQsElements.forEach((element, index) => {
    if (!element.initialized) {
      element.init();
    }
  });
});

class SocialProofSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.3,
      centeredSlides: true,
      spaceBetween: 30,
      loop: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.2,
          slidesOffsetBefore: -140,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4.2,
        },
        1440: {
          slidesPerView: 5.2,
        },
      },
      navigation: {
        nextEl: this.querySelector("[data-next-btn]"),
        prevEl: this.querySelector("[data-prev-btn]"),
      },
    });
  }
}

if (!window.customElements.get("social-proof-slider")) {
  window.customElements.define("social-proof-slider", SocialProofSlider);
}

class SocialProofVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.video = this.querySelector("video");
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", this.toggleVideo.bind(this));
  }

  toggleVideo() {
    const isPaused = this.classList.contains("paused");
    if (isPaused) {
      this.video.play();
      this.classList.remove("paused");
    } else {
      this.video.pause();
      this.classList.add("paused");
    }
  }
}

if (!window.customElements.get("social-proof-video")) {
  window.customElements.define("social-proof-video", SocialProofVideo);
}

class BenefitsSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.3,
      centeredSlides: true,
      spaceBetween: 30,
      loop: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
        },
      },
      navigation: {
        nextEl: this.querySelector("[data-next-btn]"),
        prevEl: this.querySelector("[data-prev-btn]"),
      },
    });
  }
}

if (!window.customElements.get("benefits-slider")) {
  window.customElements.define("benefits-slider", BenefitsSlider);
}

class FeaturedArticlesSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 32,
      loop: false,
      freeMode: true,
      slidesOffsetAfter: 20,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 32,
          slidesOffsetAfter: 200,
        },
      },
    });
  }
}

if (!window.customElements.get("featured-articles-swiper")) {
  window.customElements.define(
    "featured-articles-swiper",
    FeaturedArticlesSwiper
  );
}

class ArticlesCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 16,
      loop: false,
      freeMode: true,
      slidesOffsetAfter: 20,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
      },
    });
  }
}

if (!window.customElements.get("articles-carousel")) {
  window.customElements.define("articles-carousel", ArticlesCarousel);
}

document
  .querySelectorAll("[data-scroll-to-clarity-product]")
  .forEach((element) => {
    element.addEventListener("click", () => {
      const clarityProduct = document.querySelector("[data-clarity-product]");
      if (clarityProduct) {
        clarityProduct.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  });

class FooterAccessibility extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", () => {
      document.querySelector("#userwayAccessibilityIcon").click();
    });
  }
}

if (!window.customElements.get("footer-accessibility")) {
  window.customElements.define("footer-accessibility", FooterAccessibility);
}

class HeaderPhone extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", () => {
      navigator.clipboard.writeText(this.getAttribute("data-phone"));
    });
  }
}

if (!window.customElements.get("header-phone")) {
  window.customElements.define("header-phone", HeaderPhone);
}
/* =========================================================
   Echo Cart Drawer – Stabilized (SINGLE SOURCE OF TRUTH)
   - Keeps drawer open after cart mutations
   - Upsell drag-to-scroll that doesn't break buttons
   - Discount chips persist + removable even after refresh
   - Discount success is determined by cart.total_discount (reliable)
   - Empty cart state: shows ONLY Figma quiz content + button
========================================================= */

(() => {
  const DRAWER_SELECTOR = "cart-drawer.cart-drawer";
  const OVERLAY_SELECTOR = ".cart-drawer-overlay";
  const INVALID_RED = "#B63E38";

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function setCartOverlay(isOpen) {
    const overlay = document.querySelector(OVERLAY_SELECTOR);
    if (!overlay) return;
    overlay.classList.toggle("open", !!isOpen);
  }

  function keepDrawerOpen(drawer) {
    if (!drawer) return;
    drawer.classList.add("open");
    document.body.classList.add("cart-drawer-open");
    setCartOverlay(true);
  }

  function closeDrawer(drawer) {
    const d = drawer || getDrawer();
    if (!d) return;
    d.classList.remove("open");
    document.body.classList.remove("cart-drawer-open");
    setCartOverlay(false);
  }

  document.addEventListener(
    "click",
    (e) => {
      if (e.target.closest(".cart-drawer-overlay") || e.target.closest("[data-close-cart-drawer]")) {
        closeDrawer();
      }
    },
    true
  );

  // -----------------------------
  // Quiz open (Safari-safe)
  // -----------------------------
  document.addEventListener(
    "click",
    (e) => {
      const link = e.target.closest("[data-open-quiz]");
      if (!link) return;

      // Don't let overlay/capture handlers steal this click
      e.preventDefault();
      e.stopPropagation();
      // IMPORTANT: don't use stopImmediatePropagation unless you absolutely must

      // Close drawer first (optional, but helps)
      try { closeDrawer(); } catch (_) {}

      // 1) Provider/API-based open (add your real provider here if you know it)
      // Examples (keep whichever matches your quiz):
      if (window.EchoQuiz?.open) return window.EchoQuiz.open();
      if (window.OctaneAI?.quiz?.open) return window.OctaneAI.quiz.open();
      if (window.AttentiveQuiz?.open) return window.AttentiveQuiz.open();

      // 2) Launcher click fallback (common for JS-rendered quizzes)
      const launcher =
        document.querySelector("[data-quiz-launcher]") ||
        document.querySelector(".quiz-launcher") ||
        document.querySelector("#quiz-launcher") ||
        document.querySelector('[href="#quiz"]');

      if (launcher) {
        launcher.click();
        return;
      }

      // 3) Hard fallback: navigate
      const href = link.getAttribute("href") || "https://echowater.com/#quiz";
      window.location.assign(href);
    },
    true
  );

  function enforceUpsellsVisibility(drawer, cart) {
    if (!drawer) return;

    const upsellRoot =
      drawer.querySelector("[data-cart-upsells]") ||
      drawer.querySelector(".cart-upsells") ||
      drawer.querySelector(".cart-upsell-scroll");

    if (!upsellRoot) return;

    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const itemCount = Number(cart?.item_count || 0);

    // hide after 2 items on mobile
    if (isMobile && itemCount >= 2) {
      upsellRoot.style.display = "none";
    } else {
      upsellRoot.style.display = "";
    }
  }

  // =============================
  // Pin "FREE Water Quality Analysis" to first position in upsells
  // =============================
  const PINNED_UPSELL_TITLE = "FREE Water Quality Analysis";

  function findUpsellScroller(drawerEl) {
    const d = drawerEl || getDrawer?.();
    if (!d) return null;

    // Try common containers (adjust if yours differs)
    const root =
      d.querySelector("[data-cart-upsells]") ||
      d.querySelector(".cart-upsells") ||
      d.querySelector(".cart-upsell-scroll") ||
      d.querySelector("[data-upsell-scroll]");

    if (!root) return null;

    // If root is wrapper, get the direct scroller/list element
    return (
      root.querySelector(".cart-upsell-scroll") ||
      root.querySelector("[data-upsell-list]") ||
      root
    );
  }

  function pinFreeWaterQualityAnalysisFirst(drawerEl) {
    const scroller = findUpsellScroller(drawerEl);
    if (!scroller) return;

    const cards = Array.from(scroller.children || []).filter(Boolean);
    if (!cards.length) return;

    const pinned = cards.find((node) => {
      // Prefer a title element if you have one; otherwise textContent fallback
      const titleEl =
        node.querySelector("[data-upsell-title]") ||
        node.querySelector(".upsell-title") ||
        node.querySelector("h3,h4,h5,a,button,div,span");
      const text = (titleEl?.textContent || node.textContent || "").trim().toLowerCase();
      return text.includes(PINNED_UPSELL_TITLE.toLowerCase());
    });

    if (!pinned) return;

    // Already first? Great.
    if (scroller.firstElementChild === pinned) return;

    scroller.insertBefore(pinned, scroller.firstElementChild);
  }

  function observeUpsellsAndPin(drawerEl) {
    const scroller = findUpsellScroller(drawerEl);
    if (!scroller) return;

    // Avoid double-binding observers
    if (scroller.__pinObserverBound) return;
    scroller.__pinObserverBound = true;

    // Initial pin (in case it already rendered)
    pinFreeWaterQualityAnalysisFirst(drawerEl);

    const obs = new MutationObserver(() => {
      // Re-pin anytime the upsell list changes
      pinFreeWaterQualityAnalysisFirst(drawerEl);
    });

    obs.observe(scroller, { childList: true, subtree: false });

    // Store so you can disconnect later if you ever destroy drawer
    scroller.__pinObserver = obs;
  }

  async function fetchCartJson() {
    const res = await fetch("/cart.js", {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
    });
    if (!res.ok) return null;
    return res.json();
  }

  // ------------ Upsell drag-to-scroll (SAFE: does not break buttons) ------------
  function initCartUpsellDragScroll(root = document) {
    const scrollers = root.querySelectorAll(".cart-upsell-scroll");

    const isInteractiveTarget = (target) => {
      if (!target) return false;
      return !!target.closest(
        "button, a, input, select, textarea, label, [role='button'], [data-upsell-no-drag]"
      );
    };

    scrollers.forEach((el) => {
      if (el.dataset.dragScrollInit === "1") return;
      el.dataset.dragScrollInit = "1";

      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let moved = false;

      const getPageX = (e) =>
        (e.touches && e.touches[0] && e.touches[0].pageX) || e.pageX || 0;

      const onDown = (e) => {
        if (isInteractiveTarget(e.target)) return;
        if (e.button !== undefined && e.button !== 0) return;

        isDown = true;
        moved = false;

        startX = getPageX(e) - el.getBoundingClientRect().left;
        scrollLeft = el.scrollLeft;

        if (e.pointerId && el.setPointerCapture) {
          try {
            el.setPointerCapture(e.pointerId);
          } catch (_) {}
        }
      };

      const onMove = (e) => {
        if (!isDown) return;

        const x = getPageX(e) - el.getBoundingClientRect().left;
        const walk = x - startX;

        if (!moved && Math.abs(walk) > 6) moved = true;

        if (moved) {
          el.scrollLeft = scrollLeft - walk;
          e.preventDefault();
        }
      };

      const onUp = (e) => {
        if (!isDown) return;
        isDown = false;

        if (moved) {
          const stopClick = (evt) => {
            if (isInteractiveTarget(evt.target)) return;
            evt.preventDefault();
            evt.stopPropagation();
          };
          el.addEventListener("click", stopClick, { capture: true, once: true });
        }

        if (e.pointerId && el.releasePointerCapture) {
          try {
            el.releasePointerCapture(e.pointerId);
          } catch (_) {}
        }
      };

      el.addEventListener("pointerdown", onDown, { passive: true });
      el.addEventListener("pointermove", onMove, { passive: false });
      el.addEventListener("pointerup", onUp, { passive: true });
      el.addEventListener("pointercancel", onUp, { passive: true });

      el.addEventListener("touchstart", onDown, { passive: true });
      el.addEventListener("touchmove", onMove, { passive: false });
      el.addEventListener("touchend", onUp, { passive: true });

      // Mouse fallback (older browsers)
      el.addEventListener("mousedown", onDown);
      window.addEventListener("mousemove", onMove, { passive: false });
      window.addEventListener("mouseup", onUp);
    });
  }

  // =========================================================
  // Empty Cart UI (Figma)
  // =========================================================

  function buildEmptyCartQuizHTML() {
    return `
      <div class="echo-empty-cart" style="display:flex; flex-direction:column; height:100%; background:#fff;">
        
        <!-- Header -->
        <div style="position:relative; height:48px; display:flex; align-items:center;">
          <div style="position:absolute; left:20px; top:50%; transform:translateY(-50%); font-size:20px; font-weight:550; font-family:GolosText; color:#000;">
            Cart
          </div>
          <button
            type="button"
            data-close-cart-drawer
            style="position:absolute; right:20px; top:50%; transform:translateY(-50%); font-size:20px; font-weight:550; font-family:GolosText; color:#000; background:transparent; border:0; cursor:pointer;"
            aria-label="Close cart"
          >&#x2715;</button>
        </div>

        <!-- Divider -->
        <div style="height:1px; background:#E9E9E9; width:100%;"></div>

        <!-- Empty message -->
        <div style="padding:16px 20px; text-align:center; font-size:14px; color:#6b6b6b;">
          Your cart is empty.
        </div>

        <!-- Divider -->
        <div style="height:1px; background:#E9E9E9; width:100%;"></div>

        <!-- Quiz CTA -->
        <div style="flex:1; display:flex; align-items:flex-start; justify-content:center; padding:40px 22px 22px;">
          <div style="text-align:center; width:100%; max-width:340px;">
            <div style="font-size: 11px; letter-spacing: .08em; font-weight: 600; color: #6b6b6b; text-transform: uppercase;">
              NEED SOME HELP?
            </div>

            <div style="margin-top: 12px; font-size: 18px; line-height: 1.35; color: #231F20; font-weight: 400;">
              Take our quiz and get a<br/>personalized product<br/>recommendation.
            </div>

            <a
              href="https://echowater.com/#quiz"
              data-open-quiz
              style="display:block; margin: 18px auto 0; max-width: 320px; text-decoration:none;"
            >
              <span
                style="
                  display:flex;
                  align-items:center;
                  justify-content:center;
                  height: 44px;
                  border-radius: 8px;
                  background: #231F20;
                  color: #ffffff;
                  font-size: 14px;
                  font-weight: 600;
                "
              >Get Started</span>
            </a>
          </div>
        </div>
      </div>
    `;
  }

  async function applyEmptyCartStateUI(drawer) {
    const d = drawer || getDrawer();
    if (!d) return;

    const cart = await fetchCartJson();
    enforceUpsellsVisibility(drawer, cart);
    const isEmpty = (cart?.item_count || 0) === 0;

    // Where we inject + hide children
    const scope =
      d.querySelector(".drawer__inner") ||
      d.querySelector(".cart-drawer__inner") ||
      d;

    // Remove prior injected block (we re-add if needed)
    scope.querySelectorAll(".echo-empty-cart").forEach((n) => n.remove());

    // If not empty: restore and exit
    if (!isEmpty) {
      scope.querySelectorAll("[data-echo-empty-hide]").forEach((el) => {
        const orig = el.dataset.echoOrigDisplay ?? "";
        el.style.display = orig;
        el.removeAttribute("data-echo-empty-hide");
        delete el.dataset.echoOrigDisplay;
      });
      return;
    }

    // Inject empty block at the top of the scope
    const wrapper = document.createElement("div");
    wrapper.innerHTML = buildEmptyCartQuizHTML();
    const emptyBlock = wrapper.firstElementChild;

    scope.prepend(emptyBlock);

    // Hide everything else in scope
    Array.from(scope.children).forEach((child) => {
      if (child === emptyBlock) return;

      if (child.dataset.echoOrigDisplay === undefined) {
        child.dataset.echoOrigDisplay = child.style.display || "";
      }
      child.style.display = "none";
      child.setAttribute("data-echo-empty-hide", "1");
    });
  }

  // ------------ Fast drawer refresh ------------
  async function fastRefreshCartDrawer(drawer) {
    if (!drawer) return;

    const res = await fetch("/?sections=cart-drawer", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
    });
    if (!res.ok) throw new Error("Failed to refresh cart drawer section");

    const sections = await res.json();
    const html = sections["cart-drawer"];
    if (!html) throw new Error("cart-drawer section missing in response");

    const doc = new DOMParser().parseFromString(html, "text/html");
    const nextDrawer = doc.querySelector(DRAWER_SELECTOR);
    if (!nextDrawer) throw new Error("Updated <cart-drawer> not found");

    drawer.innerHTML = nextDrawer.innerHTML;

    initCartUpsellDragScroll(drawer);
    observeUpsellsAndPin(drawer);
    pinFreeWaterQualityAnalysisFirst(drawer);
    keepDrawerOpen(drawer);

    try {
      await syncDiscountUIFromShopify(drawer);
    } catch (_) {}
    try {
      await applyEmptyCartStateUI(drawer);
    } catch (_) {}
  }

  // ------------ Open drawer on add-to-cart (AJAX) ------------
  function installOpenOnAddToCart() {
    if (window.__echoOpenOnAddInstalled) return;
    window.__echoOpenOnAddInstalled = true;

    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const res = await originalFetch(...args);

      try {
        const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
        const isAdd = url.includes("/cart/add.js");

        if (isAdd && res.ok) {
          setTimeout(async () => {
            const drawer = getDrawer();
            if (!drawer) return;

            keepDrawerOpen(drawer);

            try {
              await fastRefreshCartDrawer(drawer);
            } catch (err) {
              if (typeof drawer.reloadCart === "function") {
                await drawer.reloadCart();
                initCartUpsellDragScroll(drawer);
                observeUpsellsAndPin(drawer);
                pinFreeWaterQualityAnalysisFirst(drawer);
                keepDrawerOpen(drawer);

                try {
                  await syncDiscountUIFromShopify(drawer);
                } catch (_) {}
                try {
                  await applyEmptyCartStateUI(drawer);
                } catch (_) {}
              }
            }
          }, 0);
        }
      } catch (_) {}

      return res;
    };
  }

    // ------------ Close drawer (delegated, survives re-renders) ------------
  if (!window.__echoCartDrawerCloseInstalled) {
    window.__echoCartDrawerCloseInstalled = true;

    document.addEventListener(
      "click",
      (e) => {
        const closeBtn = e.target.closest("[data-close-cart-drawer]");
        const overlayClick = e.target.closest(OVERLAY_SELECTOR);

        if (!closeBtn && !overlayClick) return;

        const drawer = getDrawer();
        if (!drawer) return;

        e.preventDefault();
        e.stopPropagation();

        closeDrawer(drawer);
      },
      true
    );

    // ESC key support (nice UX, also helps when click is blocked)
    document.addEventListener(
      "keydown",
      (e) => {
        if (e.key !== "Escape") return;
        const drawer = getDrawer();
        if (!drawer || !drawer.classList.contains("open")) return;
        closeDrawer(drawer);
      },
      true
    );
  }

  installOpenOnAddToCart();
    // ---------------------------------------------------------
    // PDP Add-to-cart spinner + drawer open (restore QA behavior)
    // - Intercepts submit on product-form / product templates
    // - Shows spinner on the clicked submit button
    // - Adds item via /cart/add.js and refreshes drawer
    // ---------------------------------------------------------

    function getSubmitButtonFromEvent(form, submitter) {
      // Prefer the actual clicked button if available
      if (submitter && form.contains(submitter)) return submitter;

      return (
        form.querySelector("button[type='submit']") ||
        form.querySelector("input[type='submit']") ||
        form.querySelector("button")
      );
    }

    function setAtcSpinner(btn, on) {
      if (!btn) return;

      if (on) {
        if (!btn.dataset.echoOriginalHtml) {
          btn.dataset.echoOriginalHtml = btn.innerHTML || "";
        }
        btn.disabled = true;
        btn.setAttribute("aria-busy", "true");
        btn.classList.add("echo-atc-loading");

        // minimal spinner (white-ish so it works on dark buttons)
        btn.innerHTML = `<span class="echo-atc-spinner" aria-hidden="true"></span>`;
      } else {
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
        btn.classList.remove("echo-atc-loading");

        if (btn.dataset.echoOriginalHtml != null) {
          btn.innerHTML = btn.dataset.echoOriginalHtml;
        }
      }
    }

    async function addToCartAjax(form) {
      const fd = new FormData(form);

      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: fd,
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });

      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        throw new Error(`add.js failed (${res.status}): ${txt}`);
      }

      return res.json();
    }

    // Capture phase so theme scripts don’t win and cause full refresh
    document.addEventListener(
      "submit",
      async (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;

        // Only intercept real product add-to-cart forms (PDP)
        const isProductForm =
          !!form.closest("product-form") ||
          form.matches("form[action*='/cart/add']") ||
          !!form.querySelector("input[name='id']");

        if (!isProductForm) return;

        // Avoid intercepting cart drawer forms (upsells handled elsewhere already)
        if (form.closest(DRAWER_SELECTOR)) return;

        e.preventDefault();
        e.stopPropagation();

        const btn = getSubmitButtonFromEvent(form, e.submitter);
        setAtcSpinner(btn, true);

        try {
          await addToCartAjax(form);

          const drawer = getDrawer();
          if (drawer) {
            keepDrawerOpen(drawer);
            await fastRefreshCartDrawer(drawer);
          }
        } catch (err) {
          console.error("[PDP ATC] failed", err);
          // if drawer exists, keep it open so UX doesn't feel broken
          keepDrawerOpen(getDrawer());
        } finally {
          setAtcSpinner(btn, false);
        }
      },
      true
    );

    // Inject spinner CSS once
    if (!document.getElementById("echo-atc-spinner-style")) {
      const style = document.createElement("style");
      style.id = "echo-atc-spinner-style";
      style.textContent = `
        .echo-atc-spinner{
          width:16px;height:16px;
          border:2px solid rgba(255,255,255,.45);
          border-top-color: rgba(255,255,255,1);
          border-radius:999px;
          display:inline-block;
          animation: echoAtcSpin .7s linear infinite;
        }
        @keyframes echoAtcSpin { to { transform: rotate(360deg); } }
      `;
      document.head.appendChild(style);
    }

  // ------------ Remove button (delegated) ------------
  async function removeLineItem(lineKeyOrId) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: lineKeyOrId, quantity: 0 }),
    });
  }

  document.addEventListener("click", async (e) => {
    const removeEl = e.target.closest(
      "[data-remove-from-cart], [data-cart-remove], button[name='remove']"
    );
    if (!removeEl) return;

    const drawer = getDrawer();
    if (drawer && !removeEl.closest(DRAWER_SELECTOR)) return;

    const lineKey =
      removeEl.dataset.removeFromCart ||
      removeEl.dataset.cartRemove ||
      removeEl.getAttribute("data-line-item-key") ||
      removeEl.value;

    if (!lineKey) return;

    e.preventDefault();
    e.stopPropagation();

    removeEl.disabled = true;
    removeEl.setAttribute("aria-busy", "true");

    try {
      await removeLineItem(lineKey);
      const d = getDrawer();
      if (d) await fastRefreshCartDrawer(d);
    } catch (err) {
      console.error("[Cart Remove] failed", err);
      keepDrawerOpen(getDrawer());
    } finally {
      removeEl.disabled = false;
      removeEl.removeAttribute("aria-busy");
    }
  });

  // ------------ Upgrade -> Every 30 Days subscription (CAPTURE PHASE) ------------
  function safeJsonParse(text) {
    try {
      return JSON.parse(text || "{}");
    } catch (e) {
      return null;
    }
  }

  async function upgradeToEvery30({ variantId, lineKey, sellingPlanId }) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    });

    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId,
      }),
    });
  }

  document.addEventListener(
    "click",
    async (e) => {
      const upgradeBtn = e.target.closest("[data-prebiotic-upgrade]");
      if (!upgradeBtn) return;

      e.preventDefault();
      e.stopPropagation();

      const root =
        upgradeBtn.closest("[data-prebiotic-upsell]") ||
        upgradeBtn.closest(DRAWER_SELECTOR) ||
        upgradeBtn.parentElement;

      if (!root) return;

      const dataEl =
        root.querySelector("[data-prebiotic-selling-plans]") ||
        upgradeBtn
          .closest("[data-prebiotic-upsell]")
          ?.querySelector("[data-prebiotic-selling-plans]");

      if (!dataEl) {
        console.error("[Prebiotic Upgrade] payload element not found");
        return;
      }

      const payload = safeJsonParse(dataEl.textContent);
      if (!payload) {
        console.error("[Prebiotic Upgrade] could not parse payload JSON");
        return;
      }

      const variantId = payload.variantId;
      const lineKey = payload.lineKey;
      const plans = Array.isArray(payload.plans) ? payload.plans : [];

      if (!variantId || !lineKey || plans.length === 0) {
        console.error("[Prebiotic Upgrade] missing variantId/lineKey/plans", payload);
        return;
      }

      const plan30 =
        plans.find((p) => /every\s*30/i.test(p?.name || "")) ||
        plans.find((p) => /\b30\b/.test(p?.name || "") && /day/i.test(p?.name || "")) ||
        plans[0];

      const sellingPlanId = plan30?.id;
      if (!sellingPlanId) return;

      const originalText = upgradeBtn.textContent;
      upgradeBtn.disabled = true;
      upgradeBtn.setAttribute("aria-busy", "true");
      upgradeBtn.textContent = "Upgrading…";
      upgradeBtn.style.opacity = "0.7";

      try {
        await upgradeToEvery30({ variantId, lineKey, sellingPlanId });
        const d = getDrawer();
        if (d) await fastRefreshCartDrawer(d);
      } catch (err) {
        console.error("[Prebiotic Upgrade] failed", err);
        keepDrawerOpen(getDrawer());
      } finally {
        upgradeBtn.disabled = false;
        upgradeBtn.removeAttribute("aria-busy");
        upgradeBtn.textContent = originalText;
        upgradeBtn.style.opacity = "";
      }
    },
    true
  );

  // ------------ Upsell Add-to-cart inside drawer (robust) ------------
  document.addEventListener(
    "submit",
    async (e) => {
      const submittedForm = e.target;
      if (!(submittedForm instanceof HTMLFormElement)) return;

      const drawer = getDrawer();
      if (!drawer || !submittedForm.closest(DRAWER_SELECTOR)) return;

      const isExplicit = submittedForm.matches("form[data-upsell-add-form]");
      const isUpsellArea = !!submittedForm.closest(
        ".cart-upsell-scroll, [data-cart-upsells], [data-upsells], .cart-upsells"
      );

      const isAddAction =
        (submittedForm.getAttribute("action") || "").includes("/cart/add") ||
        submittedForm.querySelector("input[name='id']");

      if (!isAddAction) return;
      if (!isExplicit && !isUpsellArea) return;

      e.preventDefault();
      e.stopPropagation();

      const btn =
        submittedForm.querySelector("button[type='submit'], input[type='submit']") ||
        submittedForm.querySelector("button");

      if (btn) {
        btn.disabled = true;
        btn.setAttribute("aria-busy", "true");
      }

      try {
        const fd = new FormData(submittedForm);

        const res = await fetch("/cart/add.js", {
          method: "POST",
          body: fd,
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });

        if (!res.ok) {
          const txt = await res.text().catch(() => "");
          console.error("[Upsell Add] failed", res.status, txt);
          return;
        }

        keepDrawerOpen(drawer);
        await fastRefreshCartDrawer(drawer);
      } catch (err) {
        console.error("[Upsell Add] error", err);
        keepDrawerOpen(getDrawer());
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute("aria-busy");
        }
      }
    },
    true
  );

  function setDiscountApplyingState(drawer, on) {
    const { apply, input } = getDiscountEls(drawer);
    if (!apply) return;

    if (!apply.dataset.originalLabel) {
      apply.dataset.originalLabel = apply.textContent?.trim() || "Apply";
    }

    if (on) {
      apply.disabled = true;
      apply.setAttribute("aria-busy", "true");
      apply.classList.add("is-loading");

      apply.innerHTML = `
        <span class="echo-spinner" aria-hidden="true"></span>
        <span class="echo-spinner-text">Applying</span>
      `;
      if (input) input.disabled = true;
    } else {
      apply.disabled = false;
      apply.removeAttribute("aria-busy");
      apply.classList.remove("is-loading");

      apply.textContent = apply.dataset.originalLabel || "Apply";
      if (input) input.disabled = false;
    }
  }

  // =========================================================
  // Discount UI – Shopify/cart as source of truth
  // =========================================================

  function getDiscountEls(scope = document) {
    const root = scope.querySelector("[data-cart-discount-root]") || scope;
    return {
      wrap: root.querySelector("[data-cart-discount-wrap]"),
      input: root.querySelector("[data-cart-discount-input]"),
      apply: root.querySelector("[data-cart-discount-apply]"),
      err: root.querySelector("[data-cart-discount-error]"),
      chips: root.querySelector("[data-cart-discount-chips]"),
    };
  }

  function setDiscountErrorUI(drawer, on, msg) {
    const { wrap, input, err } = getDiscountEls(drawer);
    if (wrap) wrap.classList.toggle("is-error", !!on);
    if (input) input.style.borderColor = on ? INVALID_RED : "";
    if (err) {
      err.textContent = msg || "This code can't be applied to the items in your cart";
      err.classList.toggle("hidden", !on);
      err.style.color = INVALID_RED;
    }
  }

  function normalizeCode(code) {
    return String(code || "").trim();
  }

  function uniqCaseInsensitive(arr) {
    const map = new Map();
    (arr || []).forEach((v) => {
      const s = normalizeCode(v);
      if (!s) return;
      const k = s.toLowerCase();
      if (!map.has(k)) map.set(k, s);
    });
    return Array.from(map.values());
  }

  function sanitizeCode(raw) {
    const code = normalizeCode(raw);

    if (!code || code.includes(",")) return { ok: false, code };
    if (!/^[A-Za-z0-9_-]+$/.test(code)) return { ok: false, code };
    if (code.toUpperCase() === "REMOVE") return { ok: false, code };

    return { ok: true, code };
  }

  function getCodesFromCart(cart) {
    const raw = Array.isArray(cart?.discount_codes) ? cart.discount_codes : [];

    // IMPORTANT: only keep codes Shopify marks as applicable/valid
    const codes = raw
      .filter((d) => d && d.applicable === true)
      .map((d) => normalizeCode(d.code))
      .filter(Boolean)
      .filter((c) => !c.includes(",") && c.toUpperCase() !== "REMOVE");

    return uniqCaseInsensitive(codes);
  }

  // Chip data (used for rendering; supports fallback when codes disappear)
  function getChipDataFromCart(cart) {
    const codes = getCodesFromCart(cart || {});
    if (codes.length) {
      return codes.map((c) => ({ label: c, code: c }));
    }

    const hasDiscount = Number(cart?.total_discount || 0) > 0;
    const apps = Array.isArray(cart?.discount_applications)
      ? cart.discount_applications
      : [];

    if (hasDiscount && apps.length) {
      const title = normalizeCode(apps[0]?.title) || "Discount Applied";
      return [{ label: title, code: "REMOVE" }];
    }

    return [];
  }

  function renderChips(chipsEl, chipData) {
    if (!chipsEl) return;
    chipsEl.innerHTML = "";

    const CHIP_COLOR = "#656263";

    (chipData || []).forEach(({ label, code }) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.setAttribute("data-cart-discount-remove", "");
      btn.setAttribute("data-code", code);
      btn.setAttribute(
        "aria-label",
        code === "REMOVE" ? "Remove discount" : `Remove discount ${label}`
      );

      btn.style.position = "relative";
      btn.style.display = "inline-flex";
      btn.style.alignItems = "center";
      btn.style.justifyContent = "center";
      btn.style.padding = "10px 18px";
      btn.style.border = `2px solid ${CHIP_COLOR}`;
      btn.style.borderRadius = "8px";
      btn.style.background = "transparent";
      btn.style.color = CHIP_COLOR;
      btn.style.fontSize = "14px";
      btn.style.lineHeight = "1";
      btn.style.fontWeight = "600";
      btn.style.cursor = "pointer";
      btn.style.overflow = "visible";

      btn.innerHTML = `
        <span>${label}</span>
        <span
          data-chip-x
          data-cart-discount-remove
          data-code="${code}"
          aria-hidden="true"
          style="
            position: absolute;
            top: 0px;
            right: 0px;
            transform: translate(50%, -50%);
            color: ${CHIP_COLOR};
            font-size: 20px;
            line-height: 1;
            font-weight: 700;
            padding: 0 3px;
            background: #fff;
            cursor: pointer;
          "
        >×</span>
      `;

      chipsEl.appendChild(btn);
    });
  }

  document.addEventListener(
    "click",
    (e) => {
      const x = e.target.closest("[data-chip-x]");
      if (!x) return;
      e.preventDefault();
      e.stopPropagation();
      // Let your existing remove handler run by re-dispatching from the chip button
      x.closest("[data-cart-discount-remove]")?.click();
    },
    true
  );

  // --- Discount application via Cart AJAX API (stable) ---
  async function updateCartDiscount(codeString) {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ discount: String(codeString || "").trim() }),
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(`cart/update.js failed (${res.status}): ${txt}`);
    }

    return res.json();
  }

  async function clearDiscountSessionHard() {
    await updateCartDiscount("");
  }

  async function applyCodesToShopify(codes) {
    const list = uniqCaseInsensitive(codes || []);
    if (!list.length) {
      await clearDiscountSessionHard();
      return;
    }
    await updateCartDiscount(list.join(","));
  }

  async function syncDiscountUIFromShopify(drawer) {
    const d = drawer || getDrawer();
    if (!d) return;

    const cart = await fetchCartJson();
    enforceUpsellsVisibility(drawer, cart);
    const { chips } = getDiscountEls(d);

    // Render chips with fallback support
    renderChips(chips, getChipDataFromCart(cart || {}));

    // Safety: if cart is empty but discount is somehow still active, clear it
    const codes = getCodesFromCart(cart || {});
    if ((cart?.item_count || 0) === 0 && (Number(cart?.total_discount || 0) > 0 || codes.length)) {
      await clearDiscountSessionHard();
      const cart2 = await fetchCartJson();
      renderChips(chips, getChipDataFromCart(cart2 || {}));
    }
  }

  // Apply (success determined by total_discount change)
  document.addEventListener(
    "click",
    async (e) => {
      const applyBtn = e.target.closest("[data-cart-discount-apply]");
      if (!applyBtn) return;

      const drawer = getDrawer();
      if (!drawer || !applyBtn.closest(DRAWER_SELECTOR)) return;

      e.preventDefault();
      e.stopPropagation();

      const els = getDiscountEls(drawer);
      const raw = (els.input?.value || "").trim();
      const { ok, code } = sanitizeCode(raw);

      if (!ok) {
        setDiscountErrorUI(drawer, true);
        return;
      }

      setDiscountErrorUI(drawer, false);
      setDiscountApplyingState(drawer, true);

      try {
        const before = await fetchCartJson();
        const beforeCodes = getCodesFromCart(before || {});
        const beforeTotalDiscount = Number(before?.total_discount || 0);

        const attempt = uniqCaseInsensitive([...beforeCodes, code]);

        await applyCodesToShopify(attempt);

        const after = await fetchCartJson();
        const afterTotalDiscount = Number(after?.total_discount || 0);

        const afterApplicableCodes = Array.isArray(after?.discount_codes)
          ? after.discount_codes.filter((d) => d && d.applicable === true).map((d) => normalizeCode(d.code))
          : [];

        const applied =
          afterApplicableCodes.some((c) => c.toLowerCase() === code.toLowerCase()) ||
          (Array.isArray(after?.discount_applications) && after.discount_applications.length > 0) ||
          afterTotalDiscount > beforeTotalDiscount;

        if (!applied) {
          await clearDiscountSessionHard();
          if (beforeCodes.length) await applyCodesToShopify(beforeCodes);

          await fastRefreshCartDrawer(drawer);
          const d2 = getDrawer();
          keepDrawerOpen(d2);

          setDiscountErrorUI(d2, true);
          const els2 = getDiscountEls(d2);
          if (els2.input) els2.input.value = code;
          await syncDiscountUIFromShopify(d2);
          return;
        }

        await fastRefreshCartDrawer(drawer);
        const d3 = getDrawer();
        keepDrawerOpen(d3);

        const els3 = getDiscountEls(d3);
        if (els3.input) els3.input.value = "";
        setDiscountErrorUI(d3, false);
        await syncDiscountUIFromShopify(d3);
      } catch (err) {
        console.error("[Cart Discount] apply failed", err);
        keepDrawerOpen(drawer);
        setDiscountErrorUI(drawer, true);
      } finally {
        setDiscountApplyingState(drawer, false);
      }
    },
    true
  );

  // Enter key -> Apply (capture to avoid other scripts)
  document.addEventListener(
    "keydown",
    (e) => {
      if (e.key !== "Enter") return;
      const input = e.target.closest("[data-cart-discount-input]");
      if (!input) return;

      const drawer = getDrawer();
      if (!drawer || !input.closest(DRAWER_SELECTOR)) return;

      e.preventDefault();
      e.stopPropagation();

      drawer.querySelector("[data-cart-discount-apply]")?.click();
    },
    true
  );

  document.addEventListener(
    "touchend",
    (e) => {
      const t = e.target.closest("[data-cart-discount-apply],[data-cart-discount-remove],[data-chip-x]");
      if (!t) return;
      // Helps iOS Safari treat it as a tap, not a scroll
      e.preventDefault();
      t.click();
    },
    { passive: false }
  );

  // Remove chip (supports REMOVE fallback)
  document.addEventListener(
    "click",
    async (e) => {
      const removeBtn = e.target.closest("[data-cart-discount-remove]");
      if (!removeBtn) return;

      const drawer = getDrawer();
      if (!drawer || !removeBtn.closest(DRAWER_SELECTOR)) return;

      e.preventDefault();
      e.stopPropagation();

      const codeToRemove = normalizeCode(removeBtn.getAttribute("data-code"));
      if (!codeToRemove) return;

      removeBtn.disabled = true;
      removeBtn.setAttribute("aria-busy", "true");

      try {
        // Fallback chip: clear all discounts
        if (codeToRemove.toUpperCase() === "REMOVE") {
          await clearDiscountSessionHard();

          await fastRefreshCartDrawer(drawer);
          const d2 = getDrawer();
          keepDrawerOpen(d2);

          setDiscountErrorUI(d2, false);
          await syncDiscountUIFromShopify(d2);
          return;
        }

        const cart = await fetchCartJson();
        enforceUpsellsVisibility(drawer, cart);
        const appliedCodes = getCodesFromCart(cart || {});
        const remaining = appliedCodes.filter(
          (c) => c.toLowerCase() !== codeToRemove.toLowerCase()
        );

        await clearDiscountSessionHard();
        if (remaining.length) await applyCodesToShopify(remaining);

        await fastRefreshCartDrawer(drawer);
        const d2 = getDrawer();
        keepDrawerOpen(d2);

        setDiscountErrorUI(d2, false);
        await syncDiscountUIFromShopify(d2);
      } catch (err) {
        console.error("[Cart Discount] remove failed", err);
        keepDrawerOpen(drawer);
      } finally {
        removeBtn.disabled = false;
        removeBtn.removeAttribute("aria-busy");
      }
    },
    true
  );

  document.addEventListener("DOMContentLoaded", async () => {
    const drawer = getDrawer();
    if (!drawer) return;
    const cart = await fetchCartJson().catch(() => null);
    enforceUpsellsVisibility(drawer, cart);
  });

  // Initial boot
  document.addEventListener("DOMContentLoaded", async () => {
    const drawer = getDrawer();
    if (!drawer) return;

    initCartUpsellDragScroll(drawer);
    observeUpsellsAndPin(drawer);
    pinFreeWaterQualityAnalysisFirst(drawer);

    try {
      await syncDiscountUIFromShopify(drawer);
    } catch (err) {
      console.warn("[Cart Discount] initial sync failed", err);
    }

    try {
      await applyEmptyCartStateUI(drawer);
    } catch (_) {}
  });

  // Spinner CSS (needed for discount apply state)
  if (!document.getElementById("echo-cartdrawer-spinner-style")) {
    const style = document.createElement("style");
    style.id = "echo-cartdrawer-spinner-style";
    style.textContent = `
      .echo-spinner{
        width:16px;height:16px;
        border:2px solid rgba(0,0,0,.2);
        border-top-color: rgba(0,0,0,.65);
        border-radius:999px;
        display:inline-block;
        animation: echoSpin .7s linear infinite;
        vertical-align: middle;
      }
      @keyframes echoSpin { to { transform: rotate(360deg); } }
      .echo-spinner-text{ margin-left: 8px; font-size: 13px; font-weight: 600; }
    `;
    document.head.appendChild(style);
  }
    // ---------------------------------------------------------
  // Ensure discount chips re-render (styled) after ANY drawer render
  // Covers qty +/- paths that don't hit fastRefreshCartDrawer()
  // ---------------------------------------------------------
  function installDrawerRenderHooks() {
    if (window.__echoDrawerRenderHooksInstalled) return;
    window.__echoDrawerRenderHooksInstalled = true;

    const DrawerEl = customElements.get("cart-drawer");
    const proto = DrawerEl?.prototype;
    if (!proto) return;

    const runAfterRender = async (instance) => {
      const d = instance || getDrawer();
      if (!d) return;
      try {
        await syncDiscountUIFromShopify(d);
      } catch (_) {}
      try {
        await applyEmptyCartStateUI(d);
      } catch (_) {}
    };

    // Patch updateContent(html)
    if (typeof proto.updateContent === "function" && !proto.__echoUpdateContentPatched) {
      proto.__echoUpdateContentPatched = true;
      const orig = proto.updateContent;
      proto.updateContent = function (...args) {
        const out = orig.apply(this, args);
        setTimeout(() => runAfterRender(this), 0);
        return out;
      };
    }

    // Patch reloadCart()
    if (typeof proto.reloadCart === "function" && !proto.__echoReloadCartPatched) {
      proto.__echoReloadCartPatched = true;
      const orig = proto.reloadCart;
      proto.reloadCart = function (...args) {
        const out = orig.apply(this, args);
        setTimeout(() => runAfterRender(this), 0);
        return out;
      };
    }
  }

  installDrawerRenderHooks();
})();